export enum DialogType {
    ALERT,
    CONFIRMATION,
}
